import React , { useRef, useState } from "react";
import {
    css,
    TextInput,
    AmountInput,
    DateInput,
    CustomDropdown,
    SUB_CLASS_OPTIONS,
    CLASS_OF_SHARE_OPTIONS,
    StatusBanner,
    AdditionalInfo
} from "../components/InvestmentForms/SharedComponents";

const TRANSACTION_OPTIONS = [
    { value: "Purchase of Shares",                label: "Purchase of Shares" },
    { value: "Sale of Shares to Third Party",     label: "Sale of Shares to Third Party" },
    { value: "Buyback by Investee from Investor", label: "Buyback by Investee from Investor" },
    { value: "Subscription to Rights Issue",      label: "Subscription to Rights Issue" },
    { value: "Stock Split by Investee",           label: "Stock Split by Investee" },
    { value: "Bonus Issue by Investee",           label: "Bonus Issue by Investee" },
];


const PurchaseOfSharesForm = ({ fd, hc, companyOptions, selectedTransaction, onTransactionChange }) => {
   const [subClass, setSubClass] = useState(fd.subClass || "");
    const [customSubClass, setCustomSubClass] = useState("");

    return (
    <div style={{
        border: "1px solid #eaeeed",
        borderRadius: "12px",
        padding: "30px",
        backgroundColor: "#fff",
        marginBottom: "16px"
    }}>

        <div style={{ marginBottom: "20px" }}>
            <CustomDropdown
                label="Nature Of Transaction"
                options={TRANSACTION_OPTIONS}
                placeholder="Select Transaction Type"
                value={selectedTransaction}
                onChange={onTransactionChange}
                fullWidth
            />
        </div>

        <div className={css.formContainer}>
    
            <DateInput
                label="Transaction Date"
                value={fd.transactionDate || ""}
                onChange={(v) => hc("transactionDate", v)}
            />

            <CustomDropdown
                label="Investor Company"
                options={companyOptions}
                placeholder="Select Investor"
                value={fd.investorCompany}
                onChange={v => hc("investorCompany", v)}
            />
  
            <CustomDropdown
                label="Investee Company"
                options={companyOptions}
                placeholder="Select Investee"
                value={fd.investeeCompany}
                onChange={v => hc("investeeCompany", v)}
            />

            <TextInput
                label="No Of Shares Purchased"
                placeholder="Enter No Of Shares"
                value={fd.noOfShares}
                onChange={v => hc("noOfShares", v)}
            />
 
            <CustomDropdown
                label="Class Of Share"
                options={CLASS_OF_SHARE_OPTIONS}
                placeholder="Select class of share"
                value={fd.classOfShare}
                onChange={v => hc("classOfShare", v)}
            />

            
             <CustomDropdown
              label="Sub-class"
              options={SUB_CLASS_OPTIONS}
              placeholder="Select sub-class"
              value={subClass}
              onChange={(v) => {
                  setSubClass(v);

                  if (v === "Other") {
                      hc("subClass", "");  
                  } else {
                      hc("subClass", v);
                  }
              }}
            />
            {/* {subClass === "Other" && (
                <input
                    className={css.input}
                    placeholder="Enter custom sub-class"
                    value={customSubClass}
                    onChange={(e) => {
                        setCustomSubClass(e.target.value);
                        hc("subClass", e.target.value);
                    }}
                    style={{ marginTop: "8px" }}
                />
            )} */}

            <AmountInput
                label="Purchase Price Per Share"
                value={fd.purchasePricePerShare}
                onChange={v => hc("purchasePricePerShare", v)}
            />

            <AmountInput
                label="Total Consideration"
                value={fd.totalConsideration}
                onChange={v => hc("totalConsideration", v)}
            />

            <TextInput
                label="Total Shares Outstanding"
                placeholder="Enter Total No Of Shares In Investee Company"
                value={fd.totalSharesOutstanding}
                onChange={v => hc("totalSharesOutstanding", v)}
            />
   
            <TextInput
                label="Purchased From"
                placeholder="Enter seller name"
                value={fd.purchasedFrom}
                onChange={v => hc("purchasedFrom", v)}
            />

            <CustomDropdown
            label="Cost Basis Method"
            options={[
                { value: "FIFO", label: "FIFO" },
                { value: "LIFO", label: "LIFO" },
                { value: "WAC",  label: "Weighted Average Cost" },
            ]}
            placeholder="Select Cost Basis Method"
            value={fd.costBasisMethod}
            onChange={v => hc("costBasisMethod", v)}
        />
            
            <AmountInput
                label="Cash/Bank Paid (Upfront)"
                value={fd.cashBankPaid}
                onChange={v => hc("cashBankPaid", v)}
            />

            <AmountInput
                label="Deferred Consideration"
                value={fd.deferredConsideration}
                onChange={v => hc("deferredConsideration", v)}
            />

            <DateInput
                label="Deferred Payment Date"
                value={fd.deferredPaymentDate || ""}
                onChange={v => hc("deferredPaymentDate", v)}
            />
  
            <AmountInput
                label="Contingent Consideration (FV)"
                value={fd.contingentConsideration}
                onChange={v => hc("contingentConsideration", v)}
            />

            <TextInput
                label="Contingency Description"
                placeholder="Type something..."
                value={fd.contingencyDescription}
                onChange={v => hc("contingencyDescription", v)}
            />
        
            <AmountInput
                label="Max Contingent Amount"
                value={fd.maxContingentAmount}
                onChange={v => hc("maxContingentAmount", v)}
            />
      
            <DateInput
                label="Contingent Payment Date"
                value={fd.contingentPaymentDate ? fd.contingentPaymentDate.substring(0, 10) : ""}
                onChange={v => hc("contingentPaymentDate", v)}
            />
        
            <AmountInput
                label="Transaction Costs"
                value={fd.transactionCosts}
                onChange={v => hc("transactionCosts", v)}
            />
        </div>
    </div>
    );
};



const StatusContainer = ({
  relationship,
  onRelChange,
  previousShares,
  currentShares,
  previousOwnership,
  currentOwnership,
  shareDiff,
  ownershipDiff
}) => (
  <StatusBanner
    relationship={relationship}
    onRelChange={onRelChange}
    beforeShares={previousShares}
    nowShares={currentShares}
    beforeOwnership={previousOwnership}
    nowOwnership={currentOwnership}
    shareDiff={shareDiff}
    ownershipDiff={ownershipDiff}
  />
);



const AdditionalInfoContainer = ({ formData, onChange, projectOptions, consolList }) => (
    <AdditionalInfo formData={formData} onChange={onChange} projectOptions={projectOptions} consolList={consolList} />
);



const AttachValuationContainer = () => {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files?.length) {
      setSelectedFile(e.dataTransfer.files[0]);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files?.length) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const removeFile = () => {
    setSelectedFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <div
      style={{
        padding: "24px 10px",
        marginBottom: "16px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <label className={css.label}>
        Attach Valuation Report
      </label>

      <div
        className={css.dragBox}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current?.click()}
      >
        Drag and drop your file here
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept=".pdf,.txt,.csv,.xls,.xlsx,.doc,.docx"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      {selectedFile && (
        <div
          style={{
            marginTop: "14px",
            border: "1px solid #EAEEED",
            borderRadius: "8px",
            padding: "10px 14px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span
            style={{
              fontSize: "14px",
              color: "#205a46",
              fontWeight: "500",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "80%",
            }}
          >
            {selectedFile.name}
          </span>

          <button
            onClick={removeFile}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#8FAAA3",
              fontSize: "16px",
            }}
          >
            ✕
          </button>
        </div>
      )}
    </div>
  );
};



const NotesContainer = ({ formData, onChange }) => (
    <div className={css.notesOnlyCard}>
        <label className={css.label}>Notes / Remarks</label>
        <textarea
            className={css.notesTextarea}
            placeholder="Placeholder text"
            value={formData.notesRemarks || ""}
            onChange={e => onChange("notesRemarks", e.target.value)}
        />
    </div>
);



const PurchaseOfShares = ({
   formData, 
   onChange, 
   relationship,
   projectOptions,
   consolList,
   onRelChange,
   companyOptions, 
   selectedTransaction, 
   onTransactionChange,
   previousShares,
   currentShares,
   previousOwnership,
   currentOwnership,
   shareDiff,
   ownershipDiff
  }) => (
    <>

        <PurchaseOfSharesForm
            fd={formData}
            hc={onChange}
            companyOptions={companyOptions}
            selectedTransaction={selectedTransaction}
            onTransactionChange={onTransactionChange}
        />


        <StatusContainer
            relationship={relationship}
            onRelChange={onRelChange}
            previousShares={previousShares}
            currentShares={currentShares}
            previousOwnership={previousOwnership}
            currentOwnership={currentOwnership}
            shareDiff={shareDiff}
            ownershipDiff={ownershipDiff}
        />


        <AdditionalInfoContainer
            formData={formData}
            onChange={onChange}
            projectOptions={projectOptions}
            consolList={consolList}
        />


        <AttachValuationContainer />

        <NotesContainer
            formData={formData}
            onChange={onChange}
        />
    </>
);

export default PurchaseOfShares;